<template>
  <div class="u-wrap">
    <van-form>
      <van-field v-model="model.name" label="姓名" placeholder="请输入姓名" input-align="right" />
      <van-field v-model="model.idNumber" label="身份证" placeholder="请输入证件号码" input-align="right" readonly />
      <van-field v-model="model.phone" label="联系方式" placeholder="请输入联系方式" input-align="right" />
      <van-field
        :required="true"
        v-model="model.xjzdName"
        :readonly="true"
        label="户籍地"
        placeholder="请选择"
        input-align="right"
        right-icon="arrow-down"
        @click="showArea = true"
      />
      <xzdz @config="config" @deleteAddress="deleteAddress" :defJzd="model.jzd" :defDqjzd="model.dqjzd"></xzdz>
      <!-- <van-field v-model="model.address" label="现居住地" placeholder="--" input-align="right" /> -->
      <van-field v-model="model.workUnit" label="工作单位" placeholder="请输入工作单位" input-align="right" />
      <u-picker
        dictCode="political_outlook"
        :required="true"
        readonly
        clickable
        v-model="model.politicalOutlook"
        :defValue="model.politicalOutlook_dictText"
        label="政治面貌"
        input-align="right"
        placeholder="请选择"
        right-icon="arrow"
      ></u-picker>
    </van-form>
    <div class="b-btn">
      <button class="b-button" @click="clickSumbit">修改个人信息</button>
    </div>

    <van-popup v-model="showArea" position="bottom">
      <van-area :area-list="areaList" @confirm="onConfirm" @cancel="showArea = false" />
    </van-popup>
  </div>
</template>

<script>
import { getAction, postAction } from '@/api/manage'
import { isMobile, isCardID } from '@/utils/validate'
import uPicker from '@/components/page/u-picker.vue'
import xzdz from '@/views/common/xzdz.vue'
import { areaList } from '@vant/area-data'
import { WX_USER } from "@/store/mutation-types"
import Vue from 'vue'
export default {
  components: {
    uPicker,
    xzdz,
  },
  data() {
    return {
      url: '/zhshj/djyjdybd/add',
      model: {
        name: '',
        idNumber: '',
        phone: '',
        jzd: '',
        workUnit: '',
        politicalOutlook: '',
        dqjzd: '',
        personId: '',
        xjzd: '',
        xjzdNam: '',
      },
      ifEdit: false,
      address: '',
      showArea: false,
      areaList: areaList,
    }
  },
  created() {
    this.initData()
  },

  methods: {
    initData() {
       let object = Vue.ls.get(WX_USER, {});
      let params = {
        sfgrxx: '1',
        idNumber: object.idNumber,
      }
      getAction('/zhshj/csqryglwgy/query/person', params).then((res) => {
        if (res.success) {
          let list = res.result
          let obj = list[0]
          this.model = obj
          this.model.personId = obj.id
          this.model.id = null
          this.model.sqlx = '02'
        }
      })
    },
    clickSumbit() {
      if (!this.model.name) {
          this.$u.toast('请输入姓名');
          return;
      }
     if (!isCardID(this.model.idNumber)) {
          this.$u.toast('身份证号格式错误');
          return;
      }
      postAction('/common/person/sqxg-app', this.model).then((res) => {
        if (res.success) {
          this.$router.replace({
            name: 'success',
            params: {
              isBack: true,
              title: '正在审核',
            },
          })
        }else{
          this.$toast(res.message);
        }
      })
    },
    onConfirm(values) {
      let name = ''
      let value = ''

      values.map((val, i) => {
        name += name == '' ? val.name : '/' + val.name
        if (i == values.length - 1) value = val.code
      })
      this.model.xjzd = value
      this.model.xjzdName = name

      this.showArea = false
    },
    config(data) {
      this.model.dqjzd = data.dqjzd
      this.model.jzd = data.jzd
    },
    deleteAddress() {
      this.model.dqjzd = ''
      this.model.jzd = ''
    },
  },
}
</script>

<style lang="less" scoped>
.u-wrap {
  height: 100vh;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  background-color: #f5f5f5;
}
* {
  box-sizing: border-box;
}
.u-wrap /deep/ .van-button--primary {
  background-color: #3f8ffb;
  border: 1px solid #3f8ffb;
}
.heard {
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
  z-index: 1;
}
.u-content-wrap {
  flex: 1;
  display: flex;
}

.card {
  background: #ffffff;
  padding: 0px;
  margin: 12px 8px 0px;
  box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.04);
  border-radius: 5px;
  overflow: hidden;
  height: auto;
  margin-bottom: 60px;
}

.xxnr {
  width: 90%;
  margin: 0 12px;
  height: 128px;
  border-radius: 5px;
  border: 1px solid #ededed;
  padding: 8px;
  font-size: 14px;
}

.tips {
  padding: 12px;
  color: #999999;
  line-height: 18px;
  font-size: 12px;
  display: flex;
}

.tip {
  flex: 1;
  margin-left: 6px;
}

.sjcl-bottom {
  height: 60px;
  width: 96%;
  background: #ffffff;
  position: fixed;
  bottom: 0px;
  padding: 0px 10px;
  align-items: center;
  justify-content: center;
  display: flex;
  box-shadow: 0px -3px 8px 0px rgba(216, 216, 216, 0.5);
  .voice-mode {
    flex: 1;
    margin-left: 10px;
    height: 40px;
    font-size: 16px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(211, 211, 211, 1);
    border-radius: 5px;
    text-align: center;
    line-height: 40px;
  }
}

.b-btn {
  margin-top: 20px;
  padding: 0 20px;

  .b-button {
    width: 100%;
    height: 44px;
    background: #3f8ffb;
    border-radius: 5px;
    opacity: 1;
    border: none;
    color: #ffffff;
  }

  .b-button[disabled] {
    opacity: 0.48;
  }
}
.pop-content {
  height: 100%;
  display: flex;
  flex-direction: column;
  .pop-title {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 44px;
    font-size: 15px;

    .qd {
      color: #3f8ffb;
    }
  }

  .pop-c {
    flex: 1;
    overflow: hidden;
    overflow-y: scroll;
    padding: 10px 0;
  }
}
</style>
